<template>
  <v-card v-if="propietarios.length">
    <v-toolbar card>
      <v-icon>person</v-icon>
      <v-toolbar-title class="font-weight-light">Listado de Propietarios / Inquilinos ya consolidados</v-toolbar-title>
    </v-toolbar>

    <!-- BurbujaPropietarios -->
    <!-- <v-card-text> -->
    <v-layout row wrap>
      <v-flex xs12 sm3 v-for="(propietario, i) in propietarios" :key="i">
        <v-btn @click="selecciona(propietario.idx)" dark color="red">{{ propietario.nombre }} {{ propietario.apellido1 }} {{ propietario.apellido2 }}</v-btn>
      </v-flex>
    </v-layout>
    <!-- </v-card-text> -->
  </v-card>
</template>

<script>

export default {
  props: ["propietarios", "debug"],
  data () {
    return {
      //
    }
  },

  mounted() {
    // 
  },

  watch: {
    // 
  },

  methods: {
    selecciona(uid) {
      this.$emit('verDatosCons', uid)
    }
  }
}
</script>
